import { useState, useCallback, useEffect } from 'react';
import { scaleOrdinal } from 'd3-scale';
import { schemeCategory10 } from 'd3-scale-chromatic';

const useForceInteractions = (data, fgRef) => {
    const [selectedNode, setSelectedNode] = useState(null);
    const [nodeColors, setNodeColors] = useState({});

    const initializeColors = useCallback(() => {
        const etfs = data.nodes.filter(node => node.group > 0);
        const colorScale = scaleOrdinal(schemeCategory10).domain(etfs.map(ETF => ETF.id));
        const initialColors = {};
        etfs.forEach(ETF => {
            initialColors[ETF.id] = colorScale(ETF.id); // Assign unique color based on ETF id
        });
        return initialColors;
    }, [data.nodes]);

    useEffect(() => {
        const colors = initializeColors();
        setNodeColors(colors);
    }, [data.nodes, initializeColors]);

    const updateHighlight = useCallback((node) => {
        if (node && node.group > 0) {
            const newColors = { ...nodeColors };
            data.links.forEach(link => {
                const sourceId = link.source.id || link.source;
                const targetId = link.target.id || link.target;
                if (sourceId === node.id || targetId === node.id) {
                    const connectedNode = sourceId === node.id ? link.target : link.source;
                    newColors[connectedNode.id] = newColors[node.id]; // Apply ETF color to connected stock nodes
                }
            });
            setNodeColors(newColors);
        }
    }, [data.links, nodeColors]);

    const handleNodeClick = useCallback((node) => {
        setSelectedNode(node);
        updateHighlight(node);
        // Re-center and reorient the graph if necessary
        if (fgRef.current) {
            fgRef.current.centerAt(node.x, node.y, 1000); // Optionally center the graph on the node
            fgRef.current.zoom(2, 1000); // Zoom into the node
        }
    }, [updateHighlight]);

    return {
        selectedNode,
        nodeColors,
        handleNodeClick
    };
};

export default useForceInteractions;
